import React, { KeyboardEvent } from 'react';
import { StateLanguage } from '../../languages/config/StateLanguage';

interface Props {
  status: 'connecting' | 'open' | 'closed';
  input: string;
  streaming: boolean;
  creating: boolean;
  pendingAction: boolean;
  onInputChange: (value: string) => void;
  onSend: (overrideText?: string) => void;
  onReconnect: () => void;
  onAttachClick: () => void;
  showAttachButton: boolean;
}

const CopilotFooter: React.FC<Props> = ({status, input, streaming, creating, pendingAction, onInputChange, onSend, onReconnect, onAttachClick, showAttachButton}) => {
  const {lang} = StateLanguage()

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      onSend()
    }
  }

  const disabled = streaming || creating || status !== 'open'

  if (status === 'closed') {
    return (
      <div className="card-footer pt-4">
        <div className="d-flex align-items-center justify-content-center gap-3">
          <span className="text-muted fs-7">{lang.labels.copilotConnectionLost}</span>
          <button className="btn btn-sm btn-light-primary" type="button" onClick={onReconnect}>
            {lang.labels.copilotReconnect}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="card-footer pt-4">
      {pendingAction && (
        <div className="text-center text-muted fs-9 mb-2">
          {lang.labels.copilotActionHint}
        </div>
      )}
      <textarea
        className="form-control form-control-flush mb-3"
        rows={1}
        placeholder={lang.labels.copilotInputPlaceholder}
        value={input}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        style={{resize: 'none', maxHeight: '100px', overflow: 'auto'}}
      />
      <div className="d-flex flex-stack">
        <div className="d-flex align-items-center">
          {showAttachButton && (
            <button className="btn btn-sm btn-icon btn-active-light-primary" type="button" onClick={onAttachClick} disabled={disabled}>
              <span className="svg-icon svg-icon-2 m-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22Z" fill="currentColor"/>
                  <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          )}
        </div>
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSend}
          disabled={!input.trim() || disabled}
        >
          {lang.labels.copilotSend}
        </button>
      </div>
    </div>
  )
}

export default CopilotFooter;
